const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY environment variable');
}

interface NotionProxyRequest {
  token: string;
  action: 'query-tasks' | 'update-page' | 'append-blocks' | 'get-page';
  databaseId?: string;
  pageId?: string;
  blockId?: string;
  filter?: Record<string, unknown>;
  sorts?: Record<string, unknown>[];
  properties?: Record<string, unknown>;
  children?: Record<string, unknown>[];
}

export async function notionProxy(request: NotionProxyRequest): Promise<Record<string, unknown>> {
  const response = await fetch(`${SUPABASE_URL}/functions/v1/notion-proxy`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      apikey: SUPABASE_ANON_KEY,
    },
    body: JSON.stringify(request),
  });

  return response.json();
}
